import { Navigate } from "react-router-dom";

type Props = { to: string, replace: boolean }
const VersionSensitiveNavigate = ({ to, replace }: Props) => {
  return <Navigate to={to} replace={replace}/>;
};

export default VersionSensitiveNavigate;